import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ListEmpty } from '@/shared/ui/list-empty';

export interface TableEmptyStateConfig {
  buttonText?: string;
  description?: string;
  filtered?: boolean;
  onClearFilters?: () => void;
  onRefetch?: () => void;
  title?: string;
}

export interface TableEmptyProps {
  emptyState?: TableEmptyStateConfig;
  onRefetch?: () => void;
}

export const TableEmpty: FC<TableEmptyProps> = ({ emptyState, onRefetch }) => {
  const { t } = useTranslation();
  const isFiltered = emptyState?.filtered === true;
  const clearFilters = emptyState?.onClearFilters;
  const refetch = emptyState?.onRefetch ?? onRefetch;

  if (isFiltered) {
    return (
      <ListEmpty
        actionLabel={emptyState?.buttonText ?? t('listEmpty.clearFilters')}
        description={emptyState?.description}
        title={emptyState?.title}
        variant="filtered"
        onAction={clearFilters}
      />
    );
  }

  return (
    <ListEmpty
      actionLabel={
        refetch
          ? (emptyState?.buttonText ?? t('buttons.refetch'))
          : emptyState?.buttonText
      }
      description={emptyState?.description}
      title={emptyState?.title}
      variant="empty"
      onAction={refetch}
    />
  );
};

TableEmpty.displayName = 'TableEmpty';
